/**
 * urlMixin.js
 * Mixin global que provee el metodo replaceURL para construir rutas
 * correctas hacia archivos multimedia, independientemente del formato
 * en que se haya guardado el path en la base de datos.
 *
 * Casos manejados:
 *   "./uploads/..."  ->  "apidev/uploads/..."
 *   "/uploads/..."   ->  "apidev/uploads/..."
 *   "uploads/..."    ->  "apidev/uploads/..."
 */
const urlMixin = {
  methods: {
    /**
     * Construye la URL publica de un archivo multimedia.
     *
     * @param {string} path   - Ruta del archivo tal como viene de la BD.
     * @param {string} [type] - "img" | "video". Si es "img" se busca la version _resize.
     * @returns {string} URL relativa lista para usar en :src / :href
     */
    replaceURL(path, type) {
      if (!path) return "";

      // Elimina "./" o "/" inicial para normalizar el path
      const cleanPath = path.replace(/^\.?\//, "");

      if (type === "video") {
        return "apidev/" + cleanPath;
      }

      if (type === "img") {
        const lastIndex = cleanPath.lastIndexOf(".");
        const beforeStr = cleanPath.slice(0, lastIndex);
        const afterStr = cleanPath.slice(lastIndex + 1);
        const resizePath = beforeStr + "_resize." + afterStr;
        return "apidev/" + resizePath;
      }

      // Sin tipo: devuelve la ruta directa (logo de sitio, foto de perfil, etc.)
      return "apidev/" + cleanPath;
    },
  },
};

export default urlMixin;
